module.exports = __webpack_public_path__ + "static/media/Resurreição sobre rodas.c8699ef5.jpg";